export function isRegistrationDateValid(
    date: string,
    { minimumAge }: { minimumAge: number },
): boolean {
    const userRegistrationDate = new Date(date);

    const comapreMinimumDate = new Date();
    comapreMinimumDate.setFullYear(comapreMinimumDate.getFullYear() - minimumAge);

    return userRegistrationDate < comapreMinimumDate;
}
